import { createContext, useContext, useReducer } from "react";

export const ShrinkContext = createContext({});

export const useShrinkContext = () => {
  return useContext(ShrinkContext);
};

const reducer = (state, action) => {
  switch (action.type) {
    case "toggleShrink":
      return { ...state, shrink: state.shrink === true ? false : true };
    default:
      throw new Error(`Unhandle action type: ${action.type}`);
  }
};

const initialState = {
  shrink: true,
};

export const ShrinkContextProvider = ({ children }) => {
  const [state, dispatch] = useReducer(reducer, initialState);

  const ShrinkContextValue = [state, dispatch];

  return (
    <ShrinkContext.Provider value={ShrinkContextValue}>
      {children}
    </ShrinkContext.Provider>
  );
};
